/**
 * Pure display formatters for the affiliate payments/earnings UI.
 *
 * Amounts from the backend are dollars as floats (see the affiliate payments
 * API contract). USD is rendered with a `$` prefix; any other currency falls
 * back to `<amount> <CODE>` (e.g. "9.99 EUR").
 */

export const formatMoney = (amount, currency = "usd") => {
  const value = Number(amount);
  const safeValue = Number.isFinite(value) ? value : 0;
  const formatted = safeValue.toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  const code = String(currency || "usd").toLowerCase();
  if (code === "usd") return `$${formatted}`;
  return `${formatted} ${code.toUpperCase()}`;
};

export const formatIsoDateTime = (isoString) => {
  if (!isoString) return "—";
  const d = new Date(isoString);
  if (Number.isNaN(d.getTime())) return isoString;
  return d.toLocaleString();
};

/** "2026-08" -> "August 2026" */
export const formatMonthLabel = (monthString) => {
  if (!monthString) return "—";
  const match = /^(\d{4})-(\d{2})$/.exec(String(monthString));
  if (!match) return String(monthString);
  const date = new Date(Date.UTC(Number(match[1]), Number(match[2]) - 1, 1));
  return date.toLocaleDateString("en-US", { month: "long", year: "numeric", timeZone: "UTC" });
};

export const formatPlanLabel = (planName, billingPeriod) => {
  if (!planName && !billingPeriod) return "—";
  if (planName && billingPeriod) return `${planName} · ${billingPeriod}`;
  return planName || billingPeriod;
};
